import { useNavigate } from 'react-router-dom';

/* ── Icons (36x36, Feather-style) ───────────────── */
function IconLogHours() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
      <line x1="1" y1="1" x2="3" y2="3" />
      <line x1="21" y1="1" x2="23" y2="3" />
    </svg>
  );
}

function IconPersonalReport() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  );
}

const CARDS = [
  {
    key: 'form',
    label: 'Cargar Actividades',
    description: 'Registra las horas dedicadas a tus requerimientos',
    icon: <IconLogHours />,
    path: '/activities',
  },
  {
    key: 'report',
    label: 'Reporte Personal',
    description: 'Consulta y gestiona tus horas registradas',
    icon: <IconPersonalReport />,
    path: '/activities/report',
  },
];

function ActivityPicker({ onSelect }) {
  const navigate = useNavigate();

  function handleClick(card) {
    onSelect(card.key);
    navigate(card.path, { replace: true });
  }

  return (
    <div className="cat-picker">
      <h1 className="cat-picker-title">Bitácora de Actividades</h1>
      <p className="cat-picker-sub">
        Selecciona una opción para continuar
      </p>
      <div className="cat-picker-grid">
        {CARDS.map((card, i) => (
          <button
            key={card.key}
            type="button"
            className="cat-picker-card"
            style={{ '--delay': `${i * 70}ms` }}
            onClick={() => handleClick(card)}
          >
            <span className="cat-picker-icon">{card.icon}</span>
            <span className="cat-picker-label">{card.label}</span>
            <span className="act-picker-desc">{card.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ActivityPicker;
